import styled from 'styled-components';
import THEME from '../../styles/colors';
import { dropDownBoxShadowStyles } from '../../styles/css';

export const StyledTopColorBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 52px;
  z-index: 0;
  background-color: ${({ theme }) => theme.colors.school.primary};
`;

export const StyledModalContent = styled.form`
  padding: 100px 16px 16px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  text-align: center;

  & .icon-wrapper {
    background-color: ${THEME.surface.primary};
    border-radius: 50%;
    padding: 16px;
    position: absolute;
    top: 16px;
    z-index: 1;
    left: 115px;
    ${dropDownBoxShadowStyles}
  }

  & .photo-or-initial {
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    z-index: 1;
    margin: auto;
  }

  & label {
    border: none;
    background-color: ${THEME.surface.secondary};
    cursor: pointer;
    margin-top: 12px;
    & > select {
      font-weight: bold;
      color: ${THEME.text.secondary};
      option {
        color: ${THEME.text.secondary};
      }
    }
    & > span {
      color: ${THEME.text.secondary};
    }
  }

  & .picker-form-btn {
    width: 156px;
    margin-top: 16px;

    &:last-child {
      margin-top: 4px;
      color: ${THEME.text.tertiary};
    }
  }
`;

const TYPE_STRING = 'type';
export const StyledPickerButton = styled.button.attrs(props => ({
  [TYPE_STRING]: TYPE_STRING in props ? props[TYPE_STRING] : 'button'
}))`
  display: flex;
  align-items: center;
  cursor: pointer;
  appearance: none;
  color: ${THEME.text.primary};

  background-color: ${THEME.surface.tertiary};
  &:hover {
    background-color: ${THEME.surface.secondary};
  }

  height: 28px;
  line-height: 28px;
  padding: 0 8px;
  border-radius: 8px;
`;
